module.exports = __webpack_public_path__ + "img/globe.7dd8d157.gif";